var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37262 24 12 24C12 19.4365 12 12 12 12C12 12 4.17389 12 0 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37262 24 12C19.4365 12 12 12 12 12C12 12 12 4.17389 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14325 4.17389L7.92029 6.56536H10.4348L8.40053 8.04333L9.17753 10.4348L7.14325 8.95678L5.10897 10.4348L5.88597 8.04333L3.85168 6.56536H6.3662L7.14325 4.17389Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8567 13.5652L17.6338 15.9567H20.1483L18.114 17.4346L18.891 19.8261L16.8567 18.3481L14.8225 19.8261L15.5995 17.4346L13.5652 15.9567H16.0797L16.8567 13.5652Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/panama.5f3065c7aef4f56e014b63c0cbaea2db.svg";
export { ForwardRef as ReactComponent };